import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-shared/uikit/Form";
import type { FormInputProps } from "@circle-react-shared/uikit/Form/FormInput";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface TextAreaWithCounterProps extends FormInputProps {
  maxLength: number;
}

export const TextAreaWithCounter = ({
  name,
  maxLength,
  ...rest
}: TextAreaWithCounterProps) => {
  const { watch } = useFormContext();
  const value = watch(name) as string | undefined;
  const usedCharacters = value?.length || 0;
  const charactersLeft = maxLength - usedCharacters;

  const formattedCount = new Intl.NumberFormat("en-US").format(charactersLeft);
  const formattedMaxLength = new Intl.NumberFormat("en-US").format(maxLength);
  const hasError = usedCharacters > maxLength;

  return (
    <div className="relative">
      <Form.Input
        name={name}
        variant="textarea"
        maxLength={maxLength}
        {...rest}
      />
      <div className="mt-2 text-left">
        <Typography.LabelXs
          color={hasError ? "text-v2-danger" : "text-default"}
        >
          {t(
            "community_bot.bot_builder.behavior_page.form.purpose.characters_left",
            {
              count: formattedCount,
              total: formattedMaxLength,
            },
          )}
        </Typography.LabelXs>
      </div>
    </div>
  );
};
